import { useUpdateUserId } from "@/features/user/hooks/use-update-id";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import React, { useEffect } from "react";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

// ログイン画面で利用している「パスワードを忘れた方、お困りの方はこちら」モーダル
export const UpdateIdModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    email,
    newEmail,
    emailError,
    //emailConfirmError,
    isActiveUpdateButton,
    onChangeMailAddress,
    //onChangeMailAddressConfirm,
    onClickUpdate,
    changeUpdateButtonState,
  } = useUpdateUserId({ onTapCompleteModal });

  useEffect(() => {
    changeUpdateButtonState();
  }, [newEmail]);

  // メールアドレスフォームに付与するID
  const mailAddressFormId = "mail_address_form_id";
  // メールアドレス（確認）フォームに付与するID
  //const mailAddressConfirmFormId = "mail_address_confirm_form_id";

  // 変更ボタンに付与するID
  const updateUserIdButton = "update_user_id_button";

  return (
    <BasePageModal
      title="メールアドレスの変更"
      className="md-user-profile update-id-modal"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="認証メールを送信"
          onClick={() => onClickUpdate(newEmail)}
          isActive={isActiveUpdateButton}
          id={updateUserIdButton}
          loadingNegative={true}
        />
      }
      disableOverlayClose={true}
    >
        <h2>現在のご登録の内容</h2>
        <ul className="update-id-form">
          <li>
            <MailAddressForm
              id={mailAddressFormId}
              initialValue={email}
              isReadOnly={true}
              title="現在のメールアドレス"
            />
          </li>
          <li>
            <MailAddressForm
              title="新しいメールアドレス"
              onChange={onChangeMailAddress}
              placeholder="新しいメールアドレスを入力"
              errorMessage={emailError}
              id="updateId"
            />
          </li>
        </ul>
{/*
        <div className="mt32 mb16">
          <MailAddressForm
            title="メールアドレス（確認）"
            onChange={onChangeMailAddressConfirm}
            placeholder="メールアドレスを入力"
            errorMessage={emailConfirmError}
            id={mailAddressConfirmFormId}
          />
        </div>
*/}
        <div className="message">
          <p>入力された新しいメールアドレス宛に変更用の認証メールを送信いたします。</p>
          <p>受信したメールに記載の手順に沿ってお手続きください。</p>
          <p>なお、メールアドレスの変更後は旧メールアドレスでログインできなくなりますのでご注意ください。</p>
        </div>
    </BasePageModal>
  );
};
